var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2842 12.8571V10.7143H20.7604C23.1235 10.7143 25.0461 8.79171 25.0461 6.42857C25.0461 4.06543 23.1235 2.14286 20.7604 2.14286H19.2842V0H6.42707V2.14286H4.99849V3.57143H6.42707V5.71429H19.2842V3.57143H20.7604C22.3358 3.57143 23.6175 4.85314 23.6175 6.42857C23.6175 8.004 22.3358 9.28571 20.7604 9.28571H19.2842V7.14286H6.42707V9.28571H4.95088C2.58773 9.28571 0.665161 11.2083 0.665161 13.5714C0.665161 15.9346 2.58773 17.8571 4.95088 17.8571H6.42707V20H19.2842V17.8571H20.7604V16.4286H19.2842V14.2857H6.42707V16.4286H4.95088C3.37545 16.4286 2.09373 15.1469 2.09373 13.5714C2.09373 11.996 3.37545 10.7143 4.95088 10.7143H6.42707V12.8571H19.2842ZM17.8556 4.28571H7.85564C7.85564 3.28943 7.85564 2.429 7.85564 1.42857H17.8556V4.28571ZM7.85564 15.7143H17.8556V18.5714H7.85564C7.85564 17.5751 7.85564 16.7147 7.85564 15.7143ZM7.85564 8.57143H17.8556V11.4286H7.85564C7.85564 10.4323 7.85564 9.57186 7.85564 8.57143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5304 14.7051L21.5361 15.7309L22.9937 17.1437L21.5361 18.5565L22.5304 19.5823L25.0462 17.1437L22.5304 14.7051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.65645 5.29504L4.1966 2.8565L1.65645 0.417969L0.667114 1.44854L2.13374 2.8565L0.667114 4.26446L1.65645 5.29504Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.ec61e91d9a053682b893556b94682eb8.svg";
export { ForwardRef as ReactComponent };